import { render, staticRenderFns } from "./ExportarDocumento.vue?vue&type=template&id=12bc1150&lang=pug"
import script from "./ExportarDocumento.vue?vue&type=script&lang=js"
export * from "./ExportarDocumento.vue?vue&type=script&lang=js"
import style0 from "./ExportarDocumento.vue?vue&type=style&index=0&id=12bc1150&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports